import type PlayClient from '@empathybroker/tsclient-play'
import type { InstanceEmail } from '@empathybroker/tsclient-play/dist/models/instance/instance-email'
import type { PlayResponse } from '@empathybroker/tsclient-play/dist/models/play-response'
import type { AccessTokenProvider } from '@empathyco/playboard-core-domain'
import type { ActionContext } from 'vuex'

import type { ActionClass, InstanceManagementState } from '../../../models'
import { CONTAINER } from '../../../config'

import { TYPES } from '../../../config/inversify.types'

export class RequestNewInstanceAction implements ActionClass {
  static async execute(
    this: void,
    _context: ActionContext<InstanceManagementState, any>,
    payload: { item: InstanceEmail },
  ): Promise<PlayResponse> {
    const playClient = CONTAINER.get<() => PlayClient>(TYPES.PlayClient)()
    const authToken = await CONTAINER.get<AccessTokenProvider>(TYPES.AccessTokenProvider)()
    try {
      return await playClient.requestNewInstance(authToken, payload.item)
    } catch (error) {
      throw error
    }
  }
}
